import { FC } from "react";
import { Input, InputProps } from "antd";
import { clsx } from "clsx";
import { SvgIcon } from "../../../common/components/SvgIcon";
import classes from "./SearchInput.module.less";

export interface SearchInputProps extends InputProps {}

/**
 * The search box that sits above a list: a tinted field with a search icon,
 * clearable. Filtering is the caller's; this only holds the text.
 */
export const SearchInput: FC<SearchInputProps> = ({
    className,
    placeholder = "Search",
    ...restProps
}) => (
    <Input
        className={clsx(classes.search, className)}
        placeholder={placeholder}
        prefix={<SvgIcon name="search" size={14} className={classes.icon} aria-hidden="true" />}
        allowClear
        {...restProps}
    />
);

SearchInput.displayName = "SearchInput";
